/* "Customise my strap" — HEllO EDC, 21 Oct 2026. Product pages, India store.

   The product page asks only what a first-time buyer can answer: colour and
   lug width (plus keeper colours on the straps that need them, FLEXA and
   APEX). Everything else already has a sensible standard and moves behind
   one button above Add to cart:

     [ CUSTOMISE MY STRAP                                   > ]
       Slim Dress Tang Buckle, silver · Length M

   On a phone the button opens one window listing every customisable part —
   buckle or clasp, length, extra keepers — with what is set now and a
   Change button for each. Change opens that part's usual picker; closing
   the picker brings the window back with the new value. On a wider screen
   the same button unfolds those parts inline.

   Add to cart without opening it adds the strap with its standard buckle
   (assets/wc-guided-atc.js no longer waits for the buckle or the length).

   Presentation only: the theme's own option controls, the buckle drawer and
   Easify's keepers are reused untouched, so what reaches the cart is exactly
   what it was. If this file fails, the page shows every option as before. */

(function () {
  'use strict';

  if (window.__wccustomise) return;
  window.__wccustomise = true;

  var cfg = null;
  var byId = {};
  var sheet = null;
  var lastFocus = null;

  function isMobile() { return window.innerWidth < 750; }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

  function readCfg() {
    if (cfg) return cfg;
    var el = document.querySelector('[data-wc-buckle-data]');
    if (!el) return null;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return null; }
    (cfg.families || []).forEach(function (f) {
      (f.vs || []).forEach(function (v) { byId[v.id] = { fam: f, v: v }; });
    });
    return cfg;
  }

  function money(cents) {
    var f = (cfg && cfg.moneyFormat) || '₹{{amount}}';
    var v = Math.round(cents / 100).toString();
    var sym = (f.match(/^[^{]*/) || [''])[0].replace(/&[^;]+;/g, '').trim();
    return (sym || '₹') + v;
  }

  /* ---------- what lives behind the button ---------- */

  function labelOf(fs) {
    var h = fs.querySelector('.accordion__title, legend, .form__label');
    return (h ? h.textContent : '').replace(/:\s*$/, '').trim();
  }

  function lengthFs() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return null;
    var all = vs.querySelectorAll('fieldset[data-option-index]');
    for (var i = 0; i < all.length; i++) {
      if (/length/i.test(labelOf(all[i])) && all[i].querySelectorAll('input[type="radio"]').length > 1) return all[i];
    }
    return null;
  }

  function buckleFs() {
    if (!window.WCBuckle) return null;
    var acc = document.querySelector('#variant-accordion-clasp-type');
    if (!acc) {
      var all = document.querySelectorAll('variant-selects details.variant-accordion');
      for (var i = 0; i < all.length; i++) {
        var h = all[i].querySelector('.accordion__title');
        if (h && /clasp|buckle/i.test(h.textContent)) { acc = all[i]; break; }
      }
    }
    return acc ? acc.closest('fieldset[data-option-index]') : null;
  }

  function keepersRequired() {
    var r = window.__wcKeepers;
    try { return !!(r && typeof r.applies === 'function' && r.applies()); } catch (e) { return false; }
  }

  /* Keepers stay on the page itself where the product needs them (FLEXA,
     APEX): there they are a required choice, like lug width. Elsewhere
     they are an optional extra and belong behind the button. */
  function optionalKeepers() {
    if (keepersRequired()) return [];
    var out = [];
    document.querySelectorAll('.wc-keepers-drawer[id]').forEach(function (d) {
      out.push({ drawer: d, trigger: document.querySelector('[aria-controls="' + d.id + '"]') });
    });
    return out;
  }

  function gridBtn(idx) {
    return idx == null ? null : document.querySelector('.mobile-variant-btn[data-option-index="' + idx + '"]');
  }

  function buckleParts() {
    var B = window.WCBuckle;
    if (!B || !B.componentVariantId) return null;
    readCfg();
    var hit = byId[B.componentVariantId];
    var title = B.componentTitle || (hit && hit.fam.title) || 'Buckle';
    var look = hit ? [hit.v.colour, (hit.v.finish || '').toLowerCase()].filter(Boolean).join(', ') : '';
    return {
      title: title,
      look: look,
      price: B.componentPrice > 0 ? '+' + money(B.componentPrice) : 'included',
      clasp: /clasp/i.test(title)
    };
  }

  function keeperValue(k) {
    var v = k.trigger && k.trigger.querySelector('.mobile-variant-btn__value-option');
    var t = v ? v.textContent.trim() : '';
    return !t || t === 'Select' ? 'None' : t;
  }

  function items() {
    var out = [];
    var b = buckleFs();
    var bp = buckleParts();
    if (b && bp) {
      out.push({
        key: 'buckle', label: 'Buckle / clasp', fs: b, idx: b.getAttribute('data-option-index'),
        value: bp.title + (bp.look ? ' (' + bp.look + ')' : '') + ' · ' + bp.price
      });
    }
    var l = lengthFs();
    if (l) {
      var hit = l.querySelector('input[type="radio"]:checked');
      out.push({ key: 'length', label: 'Length', fs: l, idx: l.getAttribute('data-option-index'), value: hit ? hit.value : '' });
    }
    optionalKeepers().forEach(function (k, i) {
      out.push({ key: 'keepers' + i, label: 'Extra keepers', fs: k.drawer, trigger: k.trigger, value: keeperValue(k) });
    });
    return out;
  }

  function summary(list) {
    var bits = [];
    list.forEach(function (it) {
      if (it.key === 'buckle') {
        var bp = buckleParts();
        if (bp) bits.push(bp.title + (bp.look ? ', ' + bp.look.split(',')[0].toLowerCase() : ''));
      } else if (it.key === 'length' && it.value) {
        bits.push('Length ' + it.value);
      } else if (it.key.indexOf('keepers') === 0 && it.value !== 'None') {
        bits.push('Keepers: ' + it.value);
      }
    });
    return bits.join(' · ');
  }

  /* ---------- the button ---------- */

  function rendered(el) { return !!(el && el.getClientRects().length); }

  /* Where the button goes. On a phone: straight under the option buttons
     (the variant picker), which is directly above Add to cart. On a wider
     screen: just above the real Add to cart. Always within this product's
     own section, so a second product block elsewhere on the page (or a
     hidden copy of the buttons) can never capture it. */
  function scope() {
    var vs = document.querySelector('variant-selects');
    return (vs && vs.closest('[id^="MainProduct-"]')) || document;
  }

  function spot() {
    var root = scope();
    var vs = root.querySelector('variant-selects');
    if (isMobile() && vs && vs.parentNode) return { parent: vs.parentNode, before: vs.nextSibling, after: vs };
    var wraps = root.querySelectorAll('.button--cart--wrapper');
    for (var i = 0; i < wraps.length; i++) {
      if (rendered(wraps[i])) return { parent: wraps[i].parentNode, before: wraps[i] };
    }
    if (vs && vs.parentNode) return { parent: vs.parentNode, before: vs.nextSibling, after: vs };
    return null;
  }

  var CHEV = '<svg viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M3.5 2l3 3-3 3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function place() {
    var at = spot();
    if (!at) return null;
    var host = document.querySelector('[data-wccust]');
    if (!host) {
      host = document.createElement('div');
      host.className = 'wccust';
      host.setAttribute('data-wccust', '');
      host.innerHTML =
        '<button type="button" class="wccust-btn" data-wccust-open aria-haspopup="dialog">' +
          '<span class="wccust-btn__txt"><span class="wccust-btn__t" data-wccust-title>Customise buckle</span>' +
          '<span class="wccust-btn__s" data-wccust-sum></span></span>' +
          '<span class="wccust-btn__ico">' + CHEV + '</span>' +
        '</button>';
    }
    var placed = at.after ? host.previousElementSibling === at.after : host.nextElementSibling === at.before;
    if (!placed || host.parentNode !== at.parent) at.parent.insertBefore(host, at.before || null);
    return host;
  }

  /* With buckle, length and keepers tucked away, the option row can be left
     with a single button in a two-column grid. An odd one out spans the row. */
  function balance() {
    var grid = document.querySelector('.mobile-variant-buttons-grid');
    if (!grid) return;
    var shown = [];
    Array.prototype.forEach.call(grid.children, function (el) {
      if (el.classList.contains('wccust-tuck')) return;
      var cs = window.getComputedStyle ? getComputedStyle(el) : null;
      if (cs && cs.display === 'none') return;
      shown.push(el);
    });
    var last = shown.length % 2 === 1 ? shown[shown.length - 1] : null;
    Array.prototype.forEach.call(grid.querySelectorAll('.wccust-span'), function (el) {
      if (el !== last) el.classList.remove('wccust-span');
    });
    if (last && !last.classList.contains('wccust-span')) last.classList.add('wccust-span');
  }

  function tuck(list) {
    var want = [], wantFs = [];
    list.forEach(function (it) {
      var btn = it.trigger || gridBtn(it.idx);
      if (btn) want.push(btn);
      if (it.fs) wantFs.push(it.fs);
    });
    /* Class changes only where something actually changed: the theme watches
       product-info for mutations and churn here would wake it for nothing. */
    document.querySelectorAll('.wccust-tuck').forEach(function (el) { if (want.indexOf(el) < 0) el.classList.remove('wccust-tuck'); });
    document.querySelectorAll('.wccust-tuck-fs').forEach(function (el) { if (wantFs.indexOf(el) < 0) el.classList.remove('wccust-tuck-fs'); });
    want.forEach(function (el) { if (!el.classList.contains('wccust-tuck')) el.classList.add('wccust-tuck'); });
    wantFs.forEach(function (el) { if (!el.classList.contains('wccust-tuck-fs')) el.classList.add('wccust-tuck-fs'); });
  }

  function paint() {
    try { paintNow(); } catch (e) {
      window.__wccustError = e;
      if (window.console && console.warn) console.warn('[WC] customise:', e);
    }
  }

  function paintNow() {
    var list = items();
    var on = list.length > 0;
    if (document.body.classList.contains('wccust-on') !== on) document.body.classList.toggle('wccust-on', on);
    if (!on) {
      var old = document.querySelector('[data-wccust]');
      if (old) old.hidden = true;
      return;
    }
    tuck(list);
    balance();
    var host = place();
    if (!host) return;
    if (host.hidden) host.hidden = false;
    setText(host.querySelector('[data-wccust-sum]'), summary(list));
    var openInline = document.body.classList.contains('wccust-open') && !isMobile();
    setText(host.querySelector('[data-wccust-title]'), openInline ? 'Hide customisation' : 'Customise buckle');
    var ob = host.querySelector('[data-wccust-open]');
    if (ob.getAttribute('aria-expanded') !== String(openInline)) ob.setAttribute('aria-expanded', String(openInline));
    if (sheet && !sheet.hidden) paintRows(list);
  }

  /* ---------- the window (phones) ---------- */

  function ensureSheet() {
    if (sheet && document.body.contains(sheet)) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'wccust-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="wccust-sheet__bg" data-wccust-close></div>' +
      '<div class="wccust-sheet__box" role="dialog" aria-modal="true" aria-labelledby="wccust-h">' +
        '<div class="wccust-sheet__head">' +
          '<div><b id="wccust-h">Customise your strap</b>' +
          '<span>Everything is already set to our standard. Change only what you want.</span></div>' +
          '<button type="button" class="wccust-x" data-wccust-close aria-label="Close">×</button>' +
        '</div>' +
        '<div class="wccust-rows" data-wccust-rows></div>' +
        '<button type="button" class="wccust-done" data-wccust-close>Done</button>' +
      '</div>';
    document.body.appendChild(sheet);
    return sheet;
  }

  function paintRows(list) {
    var rows = sheet.querySelector('[data-wccust-rows]');
    var html = (list || items()).map(function (it) {
      return '<button type="button" class="wccust-row" data-wccust-row="' + esc(it.key) + '">' +
        '<span class="wccust-row__l">' + esc(it.label) + '</span>' +
        '<span class="wccust-row__v">' + esc(it.value) + '</span>' +
        '<span class="wccust-row__go">Change' + CHEV + '</span>' +
      '</button>';
    }).join('');
    if (rows.getAttribute('data-sig') !== html) { rows.setAttribute('data-sig', html); rows.innerHTML = html; }
  }

  function openSheet() {
    ensureSheet();
    paintRows();
    lastFocus = document.activeElement;
    sheet.hidden = false;
    document.documentElement.classList.add('wccust-lock');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    var first = sheet.querySelector('.wccust-row');
    if (first) try { first.focus({ preventScroll: true }); } catch (e) {}
  }

  function closeSheet(keepFocus) {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    sheet.hidden = true;
    document.documentElement.classList.remove('wccust-lock');
    if (!keepFocus && lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  /* After a Change, the part's own picker takes over the screen. When it
     closes, the window comes back showing the new value. */
  var watch = null;
  function anyPickerOpen() {
    return !!document.querySelector('.mobile-drawer-active, .wc-keepers-drawer.is-open');
  }
  function returnWhenDone() {
    clearInterval(watch);
    var seen = anyPickerOpen(), started = Date.now();
    watch = setInterval(function () {
      var open = anyPickerOpen();
      if (open) { seen = true; return; }
      if (seen || Date.now() - started > 1500) {
        clearInterval(watch);
        watch = null;
        setTimeout(function () { paint(); openSheet(); }, 120);
      }
    }, 150);
  }

  function changeItem(key) {
    var it = items().filter(function (x) { return x.key === key; })[0];
    if (!it) return;
    closeSheet(true);
    if (it.key === 'buckle' && window.WCBuckleSimple) window.WCBuckleSimple.customise();
    var btn = it.trigger || gridBtn(it.idx);
    if (btn) btn.click();
    returnWhenDone();
  }

  /* ---------- wider screens: unfold inline ---------- */

  function toggleInline() {
    var open = !document.body.classList.contains('wccust-open');
    document.body.classList.toggle('wccust-open', open);
    if (open) {
      if (window.WCBuckleSimple) window.WCBuckleSimple.customise();
      var list = items();
      var first = list[0] && list[0].fs;
      list.forEach(function (it) {
        var det = it.fs && it.fs.querySelector('details.variant-accordion');
        if (det && it.key === 'buckle' && !det.open) det.open = true;
      });
      if (first && first.scrollIntoView) {
        try { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { first.scrollIntoView(); }
      }
    }
    paint();
  }

  /* ---------- wiring ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-wccust-open]')) {
      e.preventDefault();
      if (isMobile()) openSheet(); else toggleInline();
      return;
    }
    var row = t.closest('[data-wccust-row]');
    if (row) { e.preventDefault(); changeItem(row.getAttribute('data-wccust-row')); return; }
    if (t.closest('[data-wccust-close]')) { e.preventDefault(); closeSheet(); }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
  });

  var timer = null;
  function soon() { clearTimeout(timer); timer = setTimeout(paint, 120); }

  function start() {
    if (!document.querySelector('variant-selects')) return;
    paint();
    document.addEventListener('wc-buckle:change', soon);
    document.addEventListener('change', soon, true);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.wc-keepers-drawer, .po-option-root')) soon();
    }, true);
    window.addEventListener('resize', soon);
    var root = document.querySelector('product-info') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(function () {
        /* The theme re-renders the option buttons on every variant change;
           re-tuck at once, before the browser paints, so nothing flashes. */
        if (!document.querySelector('[data-wccust]') || !document.querySelector('.wccust-tuck, .wccust-tuck-fs')) paint();
      }).observe(root, { childList: true, subtree: true });
    }
    /* Keepers (Easify) and the buckle panel can arrive after this runs. */
    [400, 1200, 2500].forEach(function (ms) { setTimeout(paint, ms); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
